import Model, { ID, Integer, MODEL_LEVEL } from 'src/models/model'
import Archivable from 'src/models/model/concerns/Archivable'
import Librariable from 'src/models/model/concerns/Librariable'
import PriceCardItem from 'src/models/showing/PriceCardItem'
import ShowingBadge from 'src/models/showing/ShowingBadge'

export default class PriceCard extends Model {
  static name = 'PriceCard'

  static isConfiguration = true
  static deletable = true
  static duplicatable = true
  static paginate = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Ticketing]

  static define () {
    this.concerns = [Archivable, Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null,
        translatable: true
      },
      priceCardItems: {
        type: [PriceCardItem],
        allowDestroy: true,
        reference: true,
        acceptsNestedAttributes: true
      },
      showingBadges: {
        type: [ShowingBadge],
        default: () => { return [] },
        reference: true,
        encode (data) {
          data.showingBadgeIds = _.map(this.showingBadges.data, 'id')
        }
      },
      overrideMaxTicketsPerOrderPerShowing: {
        type: Boolean,
        default: false
      },
      maxTicketsPerOrderPerShowing: {
        type: Integer,
        default: 10
      }
    }

    this.computed = {
      ticketTypes () {
        return _.compact(_.map(this.priceCardItems.data, priceCardItem => {
          if (!priceCardItem.ticketType) return null

          return {
            description: priceCardItem.description,
            inheritedFromLibrary: (!!priceCardItem.libraryParentId)
          }
        }))
      },
      packages () {
        return _.compact(_.map(this.priceCardItems.data, priceCardItem => {
          if (!priceCardItem.itemPackage) return null

          return {
            description: priceCardItem.description,
            inheritedFromLibrary: (!!priceCardItem.libraryParentId)
          }
        }))
      }
    }
  }
}
